import { useMemo } from 'react';

/**
 * Hook to match CSS media queries in React components
 * Checks once on mount - assumes users don't resize during session
 * @param {string} query - CSS media query string (e.g., '(max-width: 768px)')
 * @returns {boolean} Whether the media query matches
 */
export const useMediaQuery = (query) => {
  const matches = useMemo(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  }, [query]);

  return matches;
};

export default useMediaQuery;
